import { useMemo } from 'react';
import { SearchType } from '../types';
import { useSearchTypeFromRoute } from '@aibees/elephant/hooks';
import { usePageType } from './use-page-type';

export function useActionSearchType(searchTypeOverride?: SearchType): {
  searchType: SearchType;
  isPeople: boolean;
} {
  const searchTypeFromRoute = useSearchTypeFromRoute();
  const { isPeoplePage } = usePageType();

  return useMemo(() => {
    let searchType: SearchType;
    if (searchTypeOverride) {
      searchType = searchTypeOverride;
    } else if (isPeoplePage) {
      searchType = SearchType.People;
    } else {
      searchType = searchTypeFromRoute ?? SearchType.Company;
    }

    const isPeople = searchType === SearchType.People;

    return { searchType, isPeople };
  }, [searchTypeOverride, searchTypeFromRoute, isPeoplePage]);
}
